import { COMPETITOR_QUERIES } from '../../infrastructure/competitor/utils/queries';
import type { CompetitorMatchedProductsRequest } from '../../infrastructure/competitor/utils/types';
import { useQuery } from '@tanstack/react-query';

export const useCompetitorService = () => {
  const useGetCompetitorMatchedProducts = (params: CompetitorMatchedProductsRequest) => {
    return useQuery(COMPETITOR_QUERIES.getCompetitorMatchedProducts(params));
  };
  return { useGetCompetitorMatchedProducts };
};
